<script setup lang="ts">
import { onMounted, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import { useAuthStore } from './stores/auth';
import { useThemeStore } from './stores/theme';
import { setPushNavigator } from './services/push-notifications';
import { setApiNavigator } from './services/api';

const { locale } = useI18n();
const authStore = useAuthStore();
const themeStore = useThemeStore();
const router = useRouter();

// Watch for locale changes
watch(locale, (newLocale) => {
  localStorage.setItem('locale', newLocale);
  document.documentElement.lang = newLocale;
});

onMounted(async () => {
  // Initialize theme
  themeStore.initTheme();

  // Provide router navigation to push notification service for deep links
  setPushNavigator((path) => router.push(path));

  // Provide router navigation to API service for force-logout (PWA-safe)
  setApiNavigator((path) => router.push(path));

  // Check authentication status
  await authStore.checkAuth();

  // Set initial document language
  document.documentElement.lang = locale.value;
});
</script>

<template>
  <router-view />
</template>
